import React from "react";
import Carousel from "../careers/carousel/Carousel";

interface ITestimonial {
  id: number;
  name: string;
  description: string;
  position: string;
  secondPosition?: string;
  image: string;
  linkedin: string;
}

interface TestimonialProps {
  title: string;
  smallDecription: string;
}

const LearningTestimonials: React.FC<TestimonialProps> = ({
  title,
  smallDecription,
}) => {
  const testimonials: ITestimonial[] = [
    {
      id: 1,
      name: "Archana Pomendkar",
      image: "/learning/testimonials/testimonial-1.png",
      description:
        "We are extremely impressed with the services provided by Dream Weavers Edutrack Pvt Ltd. We have been associated with them for almost 25 years now and from the very beginning their team has been providing instant support, ensuring all our queries and requests are resolved without any delay. The routine conducting of training for our Agents has been flawless with no errors at all. What truly stands out is their commitment to always meet the Turnaround Time (TAT) – they have consistently delivered on time, making the entire experience seamless. We are very happy with our association with them and look forward to continue this collaboration.",
      position: "Assistant Vice President – Distribution Operations",
      secondPosition: "TATA AIG General Insurance Co. Ltd.",
      linkedin: "linkedin.com/in/sarahchen",
    },
    {
      id: 2,
      name: "Abhijit Darekar",
      image: "/company/management/placeholder.png", // learning/testimonials/testimonial-2.png
      description:
        "Partnering with Dream Weavers Edutrack Pvt Ltd for our training program has been super experience. Their well structured and customized content meets our training requirements perfectly. The support and resources provided are upright ensuring seamless and effective learning process. We recommend the company to anyone looking for high quality training solutions.",
      position: "Distribution Excellence",
      secondPosition: "Zuno General Insurance Limited.",
      linkedin: "linkedin.com/in/mrodriguez",
    },
    {
      id: 3,
      name: "Viney Pandey",
      image: "/company/management/placeholder.png",
      description:
        "Dreamweaver provides exceptional service for IRDA training. The application is incredibly user-friendly and easy to navigate, making the learning experience smooth and efficient. The mock test papers are particularly valuable, helping candidates thoroughly prepare and gain confidence to clear the exam. The platform's comprehensive support and seamless experience have made it an indispensable resource for anyone preparing for the IRDA exam. Highly recommended.",
      position: "Chief Manager",
      secondPosition: "Axis Max life Insurance",
      linkedin: "linkedin.com/in/priyapatel",
    },
  ];
  return (
    <div>
      <div className="w-full flex justify-center items-center">
        <div className="text-center max-w-6xl xl:pt-5">
          <h3 className="text-xl text-center font-light xl:text-6xl sm:text-2xl md:text-3xl lg:text-4xl">
            {title}
          </h3>
          <p className="text-neutral-600 pt-2 xl:pt-4 xl:text-[1.6rem] font-light">
            {smallDecription}
          </p>
        </div>
      </div>
      <div className="py-5 p-2 xl:px-20">
        <Carousel slides={testimonials} />
      </div>
    </div>
  );
};

export default LearningTestimonials;
